import { currencySymbol } from "../../../ts/Accounts/localisation";
export function currencyThousands(number, decimals = 0) {
    if (number > 0) {
        return currencySymbol + (number / 1000).toFixed(decimals) + 'k';
    }
    return number;
}
